import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const fmt = (n) => (n == null ? '—' : `$${Number(n).toLocaleString('es-CO')}`);
const PKG = [['weight_kg', 'Peso (kg)'], ['length_cm', 'Largo (cm)'], ['width_cm', 'Ancho (cm)'], ['height_cm', 'Alto (cm)'], ['declared_value', 'Valor declarado (COP)']];

const Place = ({ label, items, value, onChange, testid }) => (
  <label className="flex flex-col gap-1 text-xs font-semibold text-slate-700">{label}
    <Input list={`${testid}-list`} value={value} onChange={e => onChange(e.target.value)} placeholder="Escribe la ciudad…" className="rounded-none h-9 w-72" data-testid={testid} />
    <datalist id={`${testid}-list`}>{items.map(l => <option key={l.code} value={`${l.city} · ${l.department}`} />)}</datalist>
  </label>
);

// Prueba de solo cotización con MiPaquete (admin). No crea envíos, guías ni cobros.
export const MipaqueteQuoteTest = () => {
  const [locs, setLocs] = useState([]);
  const [f, setF] = useState({ origin: '', destiny: '', weight_kg: '', length_cm: '', width_cm: '', height_cm: '', declared_value: '' });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/admin/logistics/mipaquete/locations').then(r => setLocs(r.data.items)).catch(() => toast.error('No se pudieron cargar las ciudades de MiPaquete')); }, []);
  const code = (v) => locs.find(l => `${l.city} · ${l.department}` === v)?.code;
  const run = async () => {
    const o = code(f.origin), d = code(f.destiny);
    if (!o || !d) { toast.error('Elige origen y destino de la lista'); return; }
    setBusy(true);
    try {
      const body = { origin_code: o, destiny_code: d, ...Object.fromEntries(PKG.map(([k]) => [k, Number(f[k])])) };
      setRes((await api.post('/admin/logistics/mipaquete/quote', body)).data.options);
    } catch (e) {
      const det = e.response?.data?.detail;
      toast.error(det?.message || (Array.isArray(det) ? 'Revisa peso, medidas y valor declarado (mínimo $10.000)' : 'No se pudo cotizar'));
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="mipaquete-quote-test">
      <p className="mb-3 text-xs text-slate-500">Prueba controlada: solo consulta tarifas en tiempo real. No genera guías, no solicita recogidas, no descuenta saldo y no cambia el checkout ni los pedidos.</p>
      <div className="flex flex-wrap items-end gap-3">
        <Place label="Origen" items={locs} value={f.origin} onChange={v => setF({ ...f, origin: v })} testid="mpq-origin" />
        <Place label="Destino" items={locs} value={f.destiny} onChange={v => setF({ ...f, destiny: v })} testid="mpq-destiny" />
        {PKG.map(([k, l]) => (
          <label key={k} className="flex flex-col gap-1 text-xs font-semibold text-slate-700">{l}
            <Input type="number" min="0" value={f[k]} onChange={e => setF({ ...f, [k]: e.target.value })} className="rounded-none h-9 w-36" data-testid={`mpq-${k}`} />
          </label>
        ))}
        <Button onClick={run} disabled={busy} className="rounded-none bg-slate-900 h-9" data-testid="mpq-quote-btn">{busy ? 'Consultando…' : 'Consultar tarifas'}</Button>
      </div>
      {res && (
        <div className="mt-4 overflow-x-auto border border-slate-200">
          <table className="w-full text-sm" data-testid="mpq-results">
            <thead className="bg-slate-50 text-left text-xs text-slate-500"><tr>
              <th className="p-2">Transportadora</th><th className="p-2">Precio</th><th className="p-2">Seguro incluido</th><th className="p-2">Tiempo estimado</th>
              <th className="p-2">Peso cobrado (kg)</th><th className="p-2">Recogida</th><th className="p-2">Ruta</th>
            </tr></thead>
            <tbody>
              {res.map((o, i) => (
                <tr key={i} className="border-t border-slate-100" data-testid={`mpq-row-${i}`}>
                  <td className="p-2 font-semibold">{o.carrier}</td><td className="p-2">{fmt(o.price)}</td><td className="p-2">{fmt(o.insurance)}</td>
                  <td className="p-2">{o.days} días</td><td className="p-2">{o.billable_kg}</td><td className="p-2">{o.pickup_service ? 'Sí' : 'No'}</td><td className="p-2">{o.route}</td>
                </tr>
              ))}
              {!res.length && <tr><td colSpan={7} className="p-3 text-slate-400">Sin transportadoras para esta ruta.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
